// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type AemSiteWideMessageQueryVariables = Types.Exact<{
  loggedIn: Types.Scalars['Boolean']['input'];
  path: Types.Scalars['String']['input'];
}>;


export type AemSiteWideMessageQuery = { __typename?: 'Query', aemSiteWideMessages: Array<{ __typename?: 'AemSitewideMessage', text: string, id: string, priority: Types.MessagePriority, isLoggedInMessage?: boolean | null }> };


export const AemSiteWideMessageDocument = gql`
    query AemSiteWideMessage($loggedIn: Boolean!, $path: String!) {
  aemSiteWideMessages(input: {loggedIn: $loggedIn, path: $path}) {
    text
    id
    priority
    isLoggedInMessage
  }
}
    `;
export type AemSiteWideMessageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>, 'query'> & ({ variables: AemSiteWideMessageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AemSiteWideMessageComponent = (props: AemSiteWideMessageComponentProps) => (
      <ApolloReactComponents.Query<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables> query={AemSiteWideMessageDocument} {...props} />
    );
    

/**
 * __useAemSiteWideMessageQuery__
 *
 * To run a query within a React component, call `useAemSiteWideMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAemSiteWideMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAemSiteWideMessageQuery({
 *   variables: {
 *      loggedIn: // value for 'loggedIn'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAemSiteWideMessageQuery(baseOptions: Apollo.QueryHookOptions<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables> & ({ variables: AemSiteWideMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>(AemSiteWideMessageDocument, options);
      }
export function useAemSiteWideMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>(AemSiteWideMessageDocument, options);
        }
export function useAemSiteWideMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>(AemSiteWideMessageDocument, options);
        }
export type AemSiteWideMessageQueryHookResult = ReturnType<typeof useAemSiteWideMessageQuery>;
export type AemSiteWideMessageLazyQueryHookResult = ReturnType<typeof useAemSiteWideMessageLazyQuery>;
export type AemSiteWideMessageSuspenseQueryHookResult = ReturnType<typeof useAemSiteWideMessageSuspenseQuery>;
export type AemSiteWideMessageQueryResult = Apollo.QueryResult<AemSiteWideMessageQuery, AemSiteWideMessageQueryVariables>;